/**
 * This file is kept for backward compatibility and to avoid updating every import in the Web app.
 * All new utility functions should be imported directly from "@punchup/utils".
 */

import {
  blobToBase64 as _blobToBase64,
  base64ToObjectURL as _base64ToObjectURL,
} from "@punchup/utils/blob";
import { checkIsTicketingPartner as _checkIsTicketingPartner } from "@punchup/utils/checkIsTicketingPartner";
import { chunkArray as _chunkArray } from "@punchup/utils/chunkArray";
import { cn as _cn } from "@punchup/utils/cn";
import _dayjs from "@punchup/utils/dayjs";
import { debounce as _debounce } from "@punchup/utils/debounce";
import { parseBoolean as _parseBoolean } from "@punchup/utils/env";
import { ErrorWithAttachedObject as _ErrorWithAttachedObject } from "@punchup/utils/errors";
import { extractTixologiEventId as _extractTixologiEventId } from "@punchup/utils/extractTixologiEventId";
import { formatPrice as _formatPrice } from "@punchup/utils/formatPrice";
import { formatPriceFromCents as _formatPriceFromCents } from "@punchup/utils/formatPriceFromCents";
import { formatRuntime as _formatRuntime } from "@punchup/utils/formatRuntime";
import { genAbsoluteURL as _genAbsoluteURL } from "@punchup/utils/genAbsoluteURL";
import { getCDNImageURLMap as _getCDNImageURLMap } from "@punchup/utils/getCDNImageURLMap";
import { getComedianInitials as _getComedianInitials } from "@punchup/utils/getComedianInitials";
import { getHostname as _getHostname } from "@punchup/utils/hostname";
import {
  createPosterImage as _createPosterImage,
  cropImage as _cropImage,
} from "@punchup/utils/image";
import { isValidEmail as _isValidEmail } from "@punchup/utils/isValidEmail";
import { parseAndFixUrl as _parseAndFixUrl } from "@punchup/utils/parseAndFixUrl";
import { parseTicketMasterEvents as _parseTicketMasterEvents } from "@punchup/utils/parseTicketMasterEvents";
import { rgbDataURL as _rgbDataURL } from "@punchup/utils/rgbDataURL";
import { runExperiment as _runExperiment } from "@punchup/utils/runExperiment";
import {
  getStoredShortLinkContext as _getStoredShortLinkContext,
  type ShortLinkContextValue as _ShortLinkContextValue,
} from "@punchup/utils/shortlink";
import { shuffleArray as _shuffleArray } from "@punchup/utils/shuffleArray";
import { slugify as _slugify } from "@punchup/utils/slugify";
import { slugifyWithoutHyphens as _slugifyWithoutHyphens } from "@punchup/utils/slugifyWithoutHyphens";

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const dayjs = _dayjs;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const blobToBase64 = _blobToBase64;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const base64ToObjectURL = _base64ToObjectURL;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export class ErrorWithAttachedObject extends _ErrorWithAttachedObject {}

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const createPosterImage = _createPosterImage;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const cropImage = _cropImage;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const parseBoolean = _parseBoolean;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const getHostname = _getHostname;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const getStoredShortLinkContext = _getStoredShortLinkContext;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export type ShortLinkContextValue = _ShortLinkContextValue;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const runExperiment = _runExperiment;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const cn = _cn;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const formatRuntime = _formatRuntime;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const formatPrice = _formatPrice;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const formatPriceFromCents = _formatPriceFromCents;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const genAbsoluteURL = _genAbsoluteURL;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const debounce = _debounce;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const slugify = _slugify;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const slugifyWithoutHyphens = _slugifyWithoutHyphens;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const rgbDataURL = _rgbDataURL;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const shuffleArray = _shuffleArray;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const parseAndFixUrl = _parseAndFixUrl;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const getComedianInitials = _getComedianInitials;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const isValidEmail = _isValidEmail;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const chunkArray = _chunkArray;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const extractTixologiEventId = _extractTixologiEventId;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const parseTicketMasterEvents = _parseTicketMasterEvents;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const getCDNImageURLMap = _getCDNImageURLMap;

/**
 * @deprecated import from "@punchup/utils" package instead
 */
export const checkIsTicketingPartner = _checkIsTicketingPartner;

// The following methods have dependencies on web app types and cannot be moved to the utils package

export {
  getComediansImageMap,
  getComedianDisplayName,
  getComedianSlug,
  checkSlugAvailability,
} from "@punchup/data/legacy/comedian";
export { getCDNImageURLArray } from "@punchup/utils/getCDNImageURLArray";

export { checkPhoneExists } from "@punchup/data/legacy/phone";
